
// import React, { useState } from 'react';
// import { TextField, Button, Box, Typography } from '@mui/material';

// function StationForm() {
//   const [formData, setFormData] = useState({
//     station_name: '',
//     vhf_id: '',
//     station_code: ''
//   });

//   const [errors, setErrors] = useState({});
//   const [serverResponse, setServerResponse] = useState({ message: '', error: '' });



//   const handleChange = (e) => {
//     const { name, value } = e.target;
  
//     let newValue = value;
  
//     // Convert specific fields to uppercase
//     if (name === 'station_name' || name === 'station_code') {
//       newValue = value.toUpperCase();
//     }
  
//     setFormData(prev => ({
//       ...prev,
//       [name]: newValue
//     }));
  
//     // Reset error and response when typing
//     setErrors(prev => ({
//       ...prev,
//       [name]: ''
//     }));
//     setServerResponse({ message: '', error: '' });
//   };
  

//   const validate = () => {
//     let valid = true;
//     let newErrors = {};

//     const alphaRegex = /^[A-Z\s]+$/;

//     // Station Name
//     if (!formData.station_name.trim()) {
//       newErrors.station_name = 'Station Name is required';
//       valid = false;
//     } else if (!alphaRegex.test(formData.station_name)) {
//       newErrors.station_name = 'Only  captal letters and spaces allowed';
//       valid = false;
//     }

//     // Station Code
//     if (!formData.station_code.trim()) {
//       newErrors.station_code = 'Station Code is required';
//       valid = false;
//     } else if (formData.station_code.length > 6 || !alphaRegex.test(formData.station_code)) {
//       newErrors.station_code = 'Max 6 characters, only  captal letters and spaces allowed';
//       valid = false;
//     }

//     // VHF ID
//     const vhf = parseInt(formData.vhf_id, 10);
//     if (!formData.vhf_id.trim()) {
//       newErrors.vhf_id = 'VHF ID is required';
//       valid = false;
//     } else if (isNaN(vhf) || vhf < 0 || vhf > 99) {
//       newErrors.vhf_id = 'VHF ID must be a number between 1 and 99';
//       valid = false;
//     }

//     setErrors(newErrors);
//     return valid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       const response = await fetch('http://localhost:5000/api/stations', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       });

//       const data = await response.json();
//       console.log('Response from backend:', data);

//       if (response.ok) {
//         setFormData({ station_name: '', vhf_id: '', station_code: '' });
//         setServerResponse({ message: data.message || 'Station added successfully!', error: '' });
//       } else {
//         setServerResponse({ message: '', error: data.error || 'Submission failed' });
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       setServerResponse({ message: '', error: 'Server error occurred' });
//     }
//   };

//   return (
//     <Box
//       component="form"
//       onSubmit={handleSubmit}
//       sx={{ maxWidth: 400, mx: 'auto', mt: 4, p: 3, border: '1px solid #ccc', borderRadius: 2 }}
//     >
//       <Typography variant="h5" mb={2} textAlign="center">
//         Add New Station
//       </Typography>

//       <TextField
//         label="Station Name"
//         name="station_name"
//         value={formData.station_name}
//         onChange={handleChange}
//         fullWidth
//         margin="normal"
//         error={!!errors.station_name}
//         helperText={errors.station_name}
//       />

//       <TextField
//         label="Station Code"
//         name="station_code"
//         value={formData.station_code}
//         onChange={handleChange}
//         fullWidth
//         margin="normal"
//         error={!!errors.station_code}
//         helperText={errors.station_code}
//       />

//       <TextField
//         label="VHF ID"
//         name="vhf_id"
//         value={formData.vhf_id}
//         onChange={handleChange}
//         fullWidth
//         margin="normal"
//         error={!!errors.vhf_id}
//         helperText={errors.vhf_id}
//       />

//       <Button type="submit" variant="contained" fullWidth sx={{ mt: 3 }}>
//         Submit
//       </Button>

//       {serverResponse.error ? (
//         <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
//           {serverResponse.error}
//         </Typography>
//       ) : (
//         serverResponse.message && (
//           <Typography color="success.main" sx={{ mt: 2, textAlign: 'center' }}>
//             {serverResponse.message}
//           </Typography>
//         )
//       )}
//     </Box>
//   );
// }

// export default StationForm;
import React, { useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import axios from './AxiosInstance';

function StationForm() {
  const [formData, setFormData] = useState({
    station_name: '',
    vhf_id: '',
    station_code: ''
  });

  const [errors, setErrors] = useState({});
  const [serverResponse, setServerResponse] = useState({ message: '', error: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;

    let newValue = value;

    // Convert specific fields to uppercase
    if (name === 'station_name' || name === 'station_code') {
      newValue = value.toUpperCase();
    }

    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }));

    // Reset error and response when typing
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));
    setServerResponse({ message: '', error: '' });
  };

  const validate = () => {
    let valid = true;
    let newErrors = {};

    const alphaRegex = /^[A-Z\s]+$/;

    // Station Name
    if (!formData.station_name.trim()) {
      newErrors.station_name = 'Station Name is required';
      valid = false;
    } else if (!alphaRegex.test(formData.station_name)) {
      newErrors.station_name = 'Only capital letters and spaces allowed';
      valid = false;
    }

    // Station Code
    if (!formData.station_code.trim()) {
      newErrors.station_code = 'Station Code is required';
      valid = false;
    } else if (formData.station_code.length > 6 || !alphaRegex.test(formData.station_code)) {
      newErrors.station_code = 'Max 6 characters, only capital letters and spaces allowed';
      valid = false;
    }

    // VHF ID
    const vhf = parseInt(formData.vhf_id, 10);
    if (!formData.vhf_id.trim()) {
      newErrors.vhf_id = 'VHF ID is required';
      valid = false;
    } else if (isNaN(vhf) || vhf < 0 || vhf > 99) {
      newErrors.vhf_id = 'VHF ID must be a number between 1 and 99';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await axios.post('/api/stations', formData, {
        headers: { 'Content-Type': 'application/json' }
      });

      console.log('Response from backend:', response.data);

      setFormData({ station_name: '', vhf_id: '', station_code: '' });
      setServerResponse({ message: response.data.message || 'Station added successfully!', error: '' });

    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.data && error.response.data.error) {
        setServerResponse({ message: '', error: error.response.data.error });
      } else {
        setServerResponse({ message: '', error: 'Server error occurred' });
      }
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ maxWidth: 400, mx: 'auto', mt: 4, p: 3, border: '1px solid #ccc', borderRadius: 2 }}
    >
      <Typography variant="h5" mb={2} textAlign="center">
        Add New Station
      </Typography>

      <TextField
        label="Station Name"
        name="station_name"
        value={formData.station_name}
        onChange={handleChange}
        fullWidth
        margin="normal"
        error={!!errors.station_name}
        helperText={errors.station_name}
      />

      <TextField
        label="Station Code"
        name="station_code"
        value={formData.station_code}
        onChange={handleChange}
        fullWidth
        margin="normal"
        error={!!errors.station_code}
        helperText={errors.station_code}
      />

      <TextField
        label="VHF ID"
        name="vhf_id"
        value={formData.vhf_id}
        onChange={handleChange}
        fullWidth
        margin="normal"
        error={!!errors.vhf_id}
        helperText={errors.vhf_id}
      />

      <Button type="submit" variant="contained" fullWidth sx={{ mt: 3 }}>
        Submit
      </Button>

      {serverResponse.error ? (
        <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
          {serverResponse.error}
        </Typography>
      ) : (
        serverResponse.message && (
          <Typography color="success.main" sx={{ mt: 2, textAlign: 'center' }}>
            {serverResponse.message}
          </Typography>
        )
      )}
    </Box>
  );
}

export default StationForm;
